import script from "./u_c_G8HA65.vue?vue&type=script&setup=true&lang=js"
export * from "./u_c_G8HA65.vue?vue&type=script&setup=true&lang=js"

import "./u_c_G8HA65.vue?vue&type=style&index=0&id=2d16caca&lang=scss&scoped=true"

import exportComponent from "/www/auto.37games.com/@mono/buildSpace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d16caca"]])

export default __exports__